(function() {
    const bulletPrefix = '⚪ ';
    const indentEm = 1.5;
    const shy = '\u00AD';
    const bulletWidthFactors = [1, 0.9, 0.8, 0.7];

    function bulletWidthFactor(bulletIndex) {
        return bulletWidthFactors[bulletIndex] !== undefined ? bulletWidthFactors[bulletIndex] : 0.7;
    }

    function buildUnits(text) {
        const units = [];

        text.split(' ').forEach((word, wordIndex) => {
            word.split(shy).forEach((part, partIndex) => {
                if (wordIndex === 0 && partIndex === 0) units.push({ text: part, breakBefore: null });
                else if (partIndex === 0) units.push({ text: part, breakBefore: 'space' });
                else units.push({ text: part, breakBefore: 'shy' });
            });
        });

        return units;
    }

    function measureTextWidth(textEl, text) {
        const tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
        tspan.textContent = text;
        textEl.appendChild(tspan);
        const width = tspan.getBBox().width;
        textEl.removeChild(tspan);
        return width;
    }

    function wrapSvgText(textEl, text, firstLineMaxWidth, continuationMaxWidth) {
        const units = buildUnits(text);
        const lines = [];
        let current = '';

        units.forEach((unit) => {
            const maxWidth = lines.length === 0 ? firstLineMaxWidth : continuationMaxWidth;

            if (current === '') {
                current = unit.text;
                return;
            }

            if (unit.breakBefore === 'space') {
                const candidate = current + ' ' + unit.text;
                if (measureTextWidth(textEl, candidate) <= maxWidth) current = candidate;
                else {
                    lines.push(current);
                    current = unit.text;
                }
                return;
            }

            const joined = current + unit.text;
            if (measureTextWidth(textEl, joined) <= maxWidth) current = joined;
            else {
                lines.push(current + '-');
                current = unit.text;
            }
        });

        if (current !== '') lines.push(current);

        return lines;
    }

    function parseBullets(textEl) {
        const bullets = [];
        let currentBullet = '';

        textEl.querySelectorAll('tspan').forEach((tspan) => {
            const text = tspan.textContent;

            if (text.startsWith(bulletPrefix)) {
                if (currentBullet !== '') bullets.push(currentBullet.trim());
                currentBullet = text.slice(bulletPrefix.length);
            }
            else currentBullet += ' ' + text.trim();
        });

        if (currentBullet !== '') bullets.push(currentBullet.trim());

        return bullets;
    }

    function renderBullets(textEl, bullets, x, maxWidth, taper) {
        const prefixWidth = measureTextWidth(textEl, bulletPrefix);
        const fontSize = parseFloat(getComputedStyle(textEl).fontSize) || 16.8;
        const indentWidth = fontSize * indentEm;

        textEl.textContent = '';

        let isFirst = true;

        bullets.forEach((bullet, bulletIndex) => {
            const bulletMaxWidth = taper
                ? maxWidth * bulletWidthFactor(bulletIndex)
                : maxWidth;
            const lines = wrapSvgText(
                textEl,
                bullet,
                bulletMaxWidth - prefixWidth,
                bulletMaxWidth - indentWidth
            );

            lines.forEach((line, lineIndex) => {
                const tspan = document.createElementNS('http://www.w3.org/2000/svg', 'tspan');
                tspan.setAttribute('x', x);

                if (lineIndex === 0) {
                    if (!isFirst) tspan.setAttribute('dy', '1.4em');
                    tspan.textContent = bulletPrefix + line;
                    isFirst = false;
                }
                else {
                    tspan.setAttribute('dx', indentEm + 'em');
                    tspan.setAttribute('dy', '1.2em');
                    tspan.textContent = line;
                }

                textEl.appendChild(tspan);
            });
        });
    }

    function reflowCirkeltext(textEl) {
        const maxWidth = parseFloat(textEl.dataset.maxWidth);
        const taper = textEl.dataset.taper === '1';
        const firstTspan = textEl.querySelector('tspan');
        const x = textEl.getAttribute('x') || (firstTspan ? firstTspan.getAttribute('x') : null);

        if (!maxWidth || !x) return;

        const bullets = parseBullets(textEl);
        if (!bullets.length) return;

        renderBullets(textEl, bullets, x, maxWidth, taper);
    }

    function reflowAll() {
        document.querySelectorAll('.c-interactive-disc .cirkeltext[data-max-width]').forEach(reflowCirkeltext);
    }

    let resizeTimer;

    function init() {
        reflowAll();
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(reflowAll, 150);
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
